<template>
	<div id="app">
		<router-view v-if="isRouterAlive"/>
	</div>
</template>

<script>
	export default {
		name: 'App',
		provide(){
			return {
				reload:this.reload
			}
		},
		data() {
			return {
				isRouterAlive:true,
			}
		},
		mounted() {
		},
		created() {
		},
		methods: {
			reload (){
				console.log(1);
		       this.isRouterAlive = false;
		       this.$nextTick(function(){
		          this.isRouterAlive = true
		       })
		    }
		},
		components: {
		}
	}
</script>


// WEBPACK FOOTER //
// src/App.vue